module.exports = __webpack_public_path__ + "img/violet_023.444808ec.png";